/* eslint-disable no-unreachable */

import React, { Component } from 'react';

import CommonService from '../../services/commonService';
import DateService from '../../services/dateService';
import { KuposButton } from '../common';
import PropTypes from 'prop-types';
import SvgAmenities from '../common/SvgAmenities';
import SvgServiceList from '../common/SvgServiceList';
import TerminalMouseOver from './TerminalMouseOver';
import getIcons from '../themes/functions/getIcons/getIcons';

export default class ServiceItem extends Component {
	static propTypes = {
		soldOut: PropTypes.bool,
		serviceItem: PropTypes.object.isRequired,
		onBookButtonPress: PropTypes.func,
		metaData: PropTypes.object,
		t: PropTypes.func,
	};
	amenitiesMoreDivHeight = [];
	amenityItemEl = [];
	terminalEl = [];
	seatTypeEl = [];
	// eslint-disable-next-line no-useless-constructor
	constructor(props) {
		super(props);
	}

	onBookButtonPress = () => {
		this.props.onBookButtonPress();
		setTimeout(() => {
			var item = document.querySelector(
				'#pb-service-list-service-item-' + this.props.serviceItem.id,
			);
			var itemCard = document.querySelector(
				'#pb-service-list-service-item-' + this.props.serviceItem.id + ' > .kupos-card',
			);
			var nav = document.querySelector('.nav-container');
			window.scrollTo(0, item.offsetTop - nav.clientHeight + 60 + itemCard.clientHeight);
		}, 500);
	};

	renderRatingsMouseOver = service => {
		// console.log("Rating mouse over log--------", service)
		return (
			<div className="ratings-mouseover normal-text">
				<div className="head-block font10">
					<div className="bold-text upper-case-text"> {this.props.t('RESULTS_PAGE.SCORE')} </div>{' '}
					<div className="upper-case-text nowrap font9"> {service.operator_details[2]} </div>{' '}
				</div>{' '}
				<div className="rating-items font9">
					{' '}
					{this.renderRatingItem(
						service.operator_details[6] &&
							service.operator_details[6][
							Object.keys(service.operator_details[6] && service.operator_details[6])[0]
							] &&
							service.operator_details[6][
								Object.keys(service.operator_details[6] && service.operator_details[6])[0]
							].toFixed
							? service.operator_details[6][
								Object.keys(service.operator_details[6] && service.operator_details[6])[0]
							].toFixed(1)
							: 0,
						this.props.t('RESULTS_PAGE.BUS_QUALITY'),
					)}{' '}
					{this.renderRatingItem(
						service.operator_details[6] &&
							service.operator_details[6][
							Object.keys(service.operator_details[6] && service.operator_details[6])[1]
							] &&
							service.operator_details[6][
								Object.keys(service.operator_details[6] && service.operator_details[6])[1]
							].toFixed
							? service.operator_details[6][
								Object.keys(service.operator_details[6] && service.operator_details[6])[1]
							].toFixed(1)
							: 0,
						this.props.t('RESULTS_PAGE.PUNCTUALITY'),
					)}{' '}
					{this.renderRatingItem(
						service.operator_details[6] &&
							service.operator_details[6][
							Object.keys(service.operator_details[6] && service.operator_details[6])[2]
							] &&
							service.operator_details[6][
								Object.keys(service.operator_details[6] && service.operator_details[6])[2]
							].toFixed
							? service.operator_details[6][
								Object.keys(service.operator_details[6] && service.operator_details[6])[2]
							].toFixed(1)
							: 0,
						this.props.t('RESULTS_PAGE.SERVICE_QUALITY'),
					)}{' '}
					{this.renderRatingItem(
						service.operator_details[6] &&
							service.operator_details[6][
							Object.keys(service.operator_details[6] && service.operator_details[6])[3]
							] &&
							service.operator_details[6][
								Object.keys(service.operator_details[6] && service.operator_details[6])[3]
							].toFixed
							? service.operator_details[6][
								Object.keys(service.operator_details[6] && service.operator_details[6])[3]
							].toFixed(1)
							: 0,
						this.props.t('RESULTS_PAGE.SERVICE_RECOMMENDATION'),
					)}{' '}
				</div>{' '}
				<div className="footer-block font9">
					{' '}
					{this.props.t('RESULTS_PAGE.RESULTS_CALCULATION') +
						Object.values(service.operator_details)[5] +
						this.props.t('RESULTS_PAGE.RESULTS_CALCULATION_USERS')}
				</div>{' '}
			</div>
		);
	};
	renderRatingItem = (rating, label) => {
		return (
			<div className="rating-item">
				{' '}
				{/* className={"rating-circle " + (((+rating/5)*100) < 60 ? 'yellow' : (((+rating/5)*100) < 80 ? 'orange' : 'red') )} */}{' '}
				<div className="rating-circle">
					{' '}
					{/* <div className="rating-circle-value">{rating}</div> */}{' '}
					<div
						className={
							'c100  small ' +
							('p' + ((+rating / 5) * 100).toFixed(0)) +
							' ' +
							((+rating / 5) * 100 < 30
								? 'red'
								: (+rating / 5) * 100 < 50
									? 'yellow'
									: (+rating / 5) * 100 < 80
										? 'orange'
										: 'green')
						}
					>
						<span className> {rating} </span>{' '}
						<div className="slice">
							<div className="bar"> </div> <div className="fill"> </div>{' '}
						</div>{' '}
					</div>{' '}
				</div>{' '}
				<div className="text font10"> {label} </div>{' '}
			</div>
		);
	};

	// renderTerminalMouseOver = (service, label, direction, operator) => {
	//   return (
	//     <div
	//       className="mouseover-popups terminal-mouseover nowrap font9"
	//       ref={el => {
	//         this.terminalEl[service.id + '1'] = el;
	//       }}
	//       style={{
	//         marginTop:
	//           '-' +
	//           (this.terminalEl[service.id + '1']
	//             ? this.terminalEl[service.id + '1'].clientHeight / 2
	//             : 0) +
	//           'px',
	//       }}
	//     >
	//       <style>
	//         .terminal-mouseover {'{'}
	//         background-color:{' '}
	//         {operator && operator.color_codes && operator.color_codes.secondary_color
	//           ? operator.color_codes.secondary_color
	//           : '#ff5c60'}
	//         ;{'}'}
	//         .service-info-row .time-info .primary-triangle {'{'}
	//         border-right: 19px solid{' '}
	//         {operator && operator.color_codes && operator.color_codes.secondary_color
	//           ? operator.color_codes.secondary_color
	//           : '#ff5c60'}
	//         ;{'}'}
	//       </style>
	//       {/* <div className="bold-text">
	//         {' '}
	//         {direction == 1
	//           ? service.boarding_stages.split('|')[3] + ' ' + service.boarding_stages.split('|')[0]
	//           : service.dropoff_stages.split('|')[3] +
	//             ' ' +
	//             service.dropoff_stages.split('|')[0]}{' '}
	//       </div>{' '} */}
	//       <div className="bold-text">
	//         {direction == 1
	//           ? (this.props.terminals &&
	//               this.props.terminals[Number(service.boarding_stages.split('|')[0])]) ||
	//             label
	//           : (this.props.terminals &&
	//               this.props.terminals[Number(service.dropoff_stages.split('|')[0])]) ||
	//             label}
	//       </div>
	//       {/* {console.log(
	//         'Terminals boarding--------------- below',
	//         this.props.terminals[Number(service.dropoff_stages.split('|')[0])],
	//       )}
	//       {console.log('Index --------------- below', Number(service.dropoff_stages.split('|')[0]))}
	//       {console.log('Terminals are--------------', this.props.terminals)} */}
	//       {/* <div className="light-text"> Terminal de busses Carlos Oviedo </div>{' '} */}
	//       <span className="primary-triangle"> </span>{' '}
	//     </div>
	//   );
	// };

	renderSeatTypeMouseOver = service => {
		return (
			<div
				className="mouseover-popups seattype-mouseover nowrap font9"
				ref={el => {
					this.seatTypeEl[service.id + '1'] = el;
				}}
				style={{
					marginTop:
						'-' +
						(this.seatTypeEl[service.id + '1']
							? this.seatTypeEl[service.id + '1'].clientHeight / 2
							: 0) +
						'px',
				}}
			>
				{/* <div className="bold-text"> {label} </div>{' '} */}
				<div className="light-text"> Terminal de busses Carlos Oviedo </div>{' '}
				<span className="primary-triangle"> </span>{' '}
			</div>
		);
	};

	getSeatName = rawSeat => {
		switch (rawSeat) {
			case 'SALON CAMA':
				return 'Salón Cama';
				break;
			case 'CLASICO':
				return 'Clásico';
				break;
			case 'Salon Sin Vent':
				return 'Salón Sin Vent';
				break;
			case 'Salon':
				return 'Salón';
				break;
			default:
				return CommonService.capitalize(rawSeat);
				break;
		}
	};

	getAmenityName = rawAnemity => {
		// console.log('Raw amenity ---------', rawAnemity);
		switch (rawAnemity) {
			case 'mobile ticket':
				return 'RESULTS_PAGE.MOBILE_TICKET';
				break;
			case 'charging plug':
				return 'RESULTS_PAGE.CHARGING_PLUG';
				break;
			case 'wifi':
				return 'RESULTS_PAGE.WIFI';
				break;
			case 'movie':
				return 'RESULTS_PAGE.ENTERTAINMENT';
				break;
			case 'baggage':
				return 'RESULTS_PAGE.BAGGAGE';
				break;
			case 'Restrooms':
				return 'RESULTS_PAGE.RESTROOMS';
				break;
			case 'air condtion':
				return 'RESULTS_PAGE.AIR_CONDITIONER';
				break;
			case 'snacks new':
				return 'RESULTS_PAGE.SNACKS';
				break;
			case 'coffee':
				return 'RESULTS_PAGE.COFFEE';
				break;
			default:
				return rawAnemity;
				break;
		}
	};

	render() {
		let { t } = this.props;
		const { serviceItem, metaData } = this.props;
		// if (metaData) console.log('helllo', metaData.amenities[10]);
		const operator = CommonService.getLocal('op') || this.props.operator;
		const isPetSeat = (Object.keys(this.props.serviceItem.pet_seat_info) || []).length > 0 && operator && operator.is_petseat_enabled;

		const showAminities = operator && !operator.is_petseat_enabled

		return (
			<div
				className={
					'pb-service-list-service-item service-card ' +
					(serviceItem.available_seats <= 0 ? 'sold-out' : '')
				}
				id={'pb-service-list-service-item-' + serviceItem.id}
			>
				{this.props.children}{' '}
				<div className="kupos-card" style={{ position: 'relative' }}>
					{this.props.serviceItem.is_direct_trip && (
						<div className="direct-ui-container">
							<img src="/assets/general/icon_desktop_background.png" alt="" className="bg" />
							<img src="/assets/general/icon_desktop.png" alt="" className="arrow" />

							<span className="text bold-text">DIRECTO</span>
						</div>
					)}
					{serviceItem.offer_text && (
						<div className="offer-text font11">
							{/* <span className="offer-percent">%</span> */}
							<div className="offer-tag-image-container">
								{/* <img src="/svgs/offer-tag.svg" alt="offer-tag" /> */}
								<img src="/static/images/icons/amenities/offer_tag.svg" alt="offer-tag" />
							</div>
							<span className="offer-text-span">
								{serviceItem.offer_text.split('[[')[0]}{' '}
								{serviceItem.offer_text.split('[[')[1] ? (
									<span style={{ color: 'red' }}>
										{' '}
										{`"${serviceItem.offer_text.split('[[')[1]}"`}
									</span>
								) : null}{' '}
								{serviceItem.offer_text.split('[[')[2]}
							</span>
						</div>
					)}
					<div className="operator-info-row flex-row font10">
						<div className="op-logo">
							<img src={serviceItem.operator_details[0]} alt="service-item" />{' '}
						</div>{' '}
						<div className="op-name light-text font11 uppercase-text">
							{' '}
							{serviceItem.operator_details[2]}{' '}
						</div>{' '}
					</div>{' '}
					<div className="service-info-row flex-row">
						<div className="flex-row time-stars-row">
							<div className="amenities-star">
								<div className="stars bold-text font13">
									{' '}
									{showAminities && serviceItem.operator_details[1].toFixed(1)}{' '}
									{showAminities && this.renderRatingsMouseOver(serviceItem)}{' '}
									{showAminities && (
										<img src="/static/images/icons/Icon-star-full-orange.png" alt="rating-star" />
									)}{' '}
								</div>{' '}
								<div className="amenities-info-row flex-row">
									<div className="amenities-row flex-row">
										{' '}
										{isPetSeat && (
											<div className="aminity-img">
												<span>
													{/* <img src="/images/seats/PetsOnBoardIIcon.svg" /> */}
													<img
														src={getIcons('petseatref', operator)}
														// src="/static/images/seats/SanAndres-ResultPage-PetsOnBoard-Ammenity.svg"
														alt=""
														style={{
															width: '30px',
															height: '30px',
															marginLeft: '16px',
															marginBottom: '33px',
														}}
													/>
												</span>
												<div
													id={'amenity' + serviceItem.id}
													className="amenities-item-mouse-over mouseover-popups nowrap font9"
													style={{ textTransform: 'inherit', marginTop: -7, left: 36 }}
												>
													Asiento Mascota
												</div>
											</div>
										)}
										<style>
											.mouseover-popups {'{'}
											background-color:{' '}
											{operator && operator.color_codes && operator.color_codes.secondary_color
												? operator.color_codes.secondary_color
												: '#ff5c60'}
											;{'}'}
											.amenities-item-mouse-over:before {'{'}
											border-bottom: 19px solid{' '}
											{operator && operator.color_codes && operator.color_codes.secondary_color
												? operator.color_codes.secondary_color
												: '#ff5c60'}{' '}
											;{'}'}
											.amenities-more-div .primary-triangle {'{'}
											border-right: 19px solid{' '}
											{operator && operator.color_codes && operator.color_codes.secondary_color
												? operator.color_codes.secondary_color
												: '#ff5c60'}
											;{'}'}
										</style>
										{showAminities && metaData && serviceItem.operator_details[4]
											? serviceItem.operator_details[4].map((val, key) => {
												return key < 2 &&
													metaData.amenities[val] && metaData.amenities[val].split('.')[0].toUpperCase() != 'WATER' ? (
													<div className="aminity-img" key={key}>
														{' '}
														{/* <imgsrc={'/static/images/icons/amenities/' + metaData.amenities[val]} key={key} /> */}{' '}
														<SvgAmenities
															name={metaData.amenities[val].split('.')[0].toUpperCase()}
														/>{' '}
														<div
															id={'amenity' + serviceItem.id}
															className="amenities-item-mouse-over mouseover-popups nowrap font9"
														>
															{t(
																this.getAmenityName(
																	metaData.amenities[val]
																		.split('.')[0]
																		.split('_')
																		.join(' '),
																),
															)}{' '}
														</div>{' '}
													</div>
												) : // <div className={'amenities-sprite ' + metaData.amenities[val].split('.')[0]}></div>
													null;
											})
											: null}{' '}
										{showAminities &&
											metaData &&
											serviceItem.operator_details[4] &&
											serviceItem.operator_details[4].length > 2 ? (
											<div className="amenities-more-icon">
												{' '}
												{/* {console.log('Metadata ammenities', metaData)}{' '} */}
												<img src={'/static/images/icons/amenities/icon_plus.svg'} alt="" />{' '}
												<div className="amenities-more-div mouseover-popups nowrap font9">
													{' '}
													{metaData && serviceItem.operator_details[4]
														? serviceItem.operator_details[4].map((val, key) => {
															return key >= 2 &&
																metaData.amenities[val].split('.')[0].toUpperCase() != 'WATER' ? (
																<div className="amenities-more-row" key={key}>
																	<SvgAmenities
																		name={metaData.amenities[val].split('.')[0].toUpperCase()}
																		color="white"
																	/>
																	<span>
																		{' '}
																		{t(
																			this.getAmenityName(
																				metaData.amenities[val]
																					.split('.')[0]
																					.split('_')
																					.join(' '),
																			),
																		)}{' '}
																	</span>{' '}
																</div>
															) : // <div className={'amenities-sprite ' + metaData.amenities[val].split('.')[0]}></div>
																null;
														})
														: null}{' '}
													<span className="primary-triangle"> </span>{' '}
												</div>{' '}
											</div>
										) : null}{' '}
									</div>{' '}
								</div>{' '}
							</div>{' '}
						</div>{' '}
						<div className="flex-row time-stars-row">
							<div className="datetime-info">
								<div className="time-row flex-row">
									<div className="time-info bold-text">
										<span className="time font13"> {serviceItem.dep_time} </span>{' '}
										<span className="ampm font8">
											{' '}
											{DateService.ampmOnly(serviceItem.dep_time)}{' '}
										</span>{' '}
										{/* {this.renderTerminalMouseOver(
                      serviceItem,
                      t('RESULTS_PAGE.BOARDING_POINT2'),
                      1,
                      operator,
                    )}{' '} */}
										<TerminalMouseOver
											terminalEl={this.terminalEl}
											service={serviceItem}
											operator={operator}
											terminals={this.props.terminals}
											label={t('RESULTS_PAGE.BOARDING_POINT2')}
											direction={1}
										/>
									</div>{' '}
									<div className="duration font9 light-text">
										<div>
											<span> {serviceItem.duration} </span>
											<span className="hours"> {t('RESULTS_PAGE.HOURS')} </span>{' '}
										</div>{' '}
										{/* <img src="/static/images/icons/icon-duration-arrow.png" /> */}{' '}
										<SvgServiceList name="duration-arrow" />
									</div>{' '}
									<div className="time-info bold-text">
										<span className="time font13"> {serviceItem.arr_time.slice(0, 5)} </span>{' '}
										{/* {console.log('Date on arrival', serviceItem.arr_time.slice(0, 5))} */}{' '}
										<span className="ampm font8">
											{' '}
											{DateService.ampmOnly(serviceItem.arr_time)}{' '}
										</span>{' '}
										{/* {this.renderTerminalMouseOver(
                      serviceItem,
                      t('RESULTS_PAGE.DROP_OFF_POINT'),
                      2,
                      operator,
                    )}{' '} */}
										<TerminalMouseOver
											terminalEl={this.terminalEl}
											service={serviceItem}
											operator={operator}
											terminals={this.props.terminals}
											label={t('RESULTS_PAGE.DROP_OFF_POINT')}
											direction={2}
										/>
									</div>{' '}
								</div>{' '}
								<div className="date-row flex-row font11 light-text">
									<span className="">
										{' '}
										{DateService.getServiceItemDate(serviceItem.travel_date)}{' '}
									</span>{' '}
									<span className="">
										{' '}
										{DateService.getServiceItemDate(serviceItem.arrival_date)}{' '}
									</span>{' '}
								</div>{' '}
							</div>{' '}
						</div>{' '}
						<div
							className={
								'seat-info font11  bold-text ' +
								(serviceItem.fare_str.split(',') && serviceItem.fare_str.split(',').length <= 1
									? 'single-type '
									: '') +
								(serviceItem.fare_str.split(',') && serviceItem.fare_str.split(',').length == 3
									? 'three-type '
									: '')
							}
						>
							{serviceItem.fare_str.split(',').map((val, key) => {
								return (
									<span
										key={key}
										className={
											'seattype-name' + serviceItem.available_seats <= 0 ? ' sold-out' : ' '
										}
									>
										{/* {CommonService.capitalize(
                      val.split(':')[0].toLowerCase() == 'semicama'
                        ? 'semi cama'
                        : val.split(':')[0].toLowerCase() == 'saloncama'
                        ? 'salon cama'
                        : val.split(':')[0],
                    )} */}
										{this.getSeatName(val.split(':')[0])}
										{/* {this.renderSeatTypeMouseOver(serviceItem)} */}
									</span>
								);
							})}{' '}
						</div>{' '}
						<style>
							.seat-price-info span {'{'}
							color: {operator && operator.color_codes.header_color && operator.operator_name === 'busnorte' || operator.operator_name === 'aeroquinta'
								? operator.color_codes.header_color : operator && operator.button_color ? operator.button_color : ''};{'}'}
						</style>
						<div
							className={
								'seat-price-info bold-text font13 ' +
								(serviceItem.fare_str.split(',') && serviceItem.fare_str.split(',').length <= 1
									? 'single-type '
									: '') +
								(serviceItem.fare_str.split(',') && serviceItem.fare_str.split(',').length == 3
									? 'three-type '
									: '')
							}
						>
							{serviceItem.fare_str.split(',').map((val, key) => {
								return (
									<span key={key}> {CommonService.currency(val.split(':')[1]).split(',')[0]} </span>
								);
							})}{' '}
						</div>{' '}
						<div
							className={
								'button-col font12 ' +
								(serviceItem.fare_str.split(',') &&
									serviceItem.fare_str.split(',').length <= 1 &&
									!(serviceItem.available_seats < 10 && serviceItem.available_seats > 0)
									? 'single-type '
									: 'single-type') +
								(serviceItem.available_seats <= 0 ? 'sold-out' : '')
							}
						>
							<KuposButton
								onClick={serviceItem.available_seats > 0 ? this.onBookButtonPress : null}
								className={serviceItem.available_seats <= 0 ? 'sold-out' : ''}
							>
								{serviceItem.available_seats > 0 ? (
									t('RESULTS_PAGE.BUY')
								) : (
									<span className="sold-out-span"> {t('RESULTS_PAGE.SOLD_OUT')} </span>
								)}{' '}
								{serviceItem.available_seats <= 0 ? <img src="/svgs/sold-out.svg" alt="" /> : null}{' '}
							</KuposButton>{' '}
							{serviceItem.available_seats < 10 && serviceItem.available_seats > 0 ? (
								<div className="fast-filling bold-text font9 secondary-text">
									{' '}
									¡ Últimos Asientos!
								</div>
							) : null}{' '}
						</div>{' '}
					</div>{' '}
				</div>{' '}
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/features/pb-service-list/ServiceItem.js